// services/userAccess.js
import api from "../libs/api";

export default {
	getUserAccess: (page, perPage, sortBy = "", sortOrder = "") => {
			return new Promise((resolve, reject) => {
				const queryParams = new URLSearchParams({
					page,
					perPage,
					sortBy,
					sortOrder,
				}).toString();
	
				api()
					.get(`/user-access-form?${queryParams}`)
					.then(({ status, data }) => {
						if (status === 200) {
							resolve(data);
						} else {
							throw new Error(`Failed with status: ${status}`);
						}
					})
					.catch((error) => reject(error));
			});
		},
	
		getUserAccessDetails: (id) => {
			return new Promise((resolve, reject) => {
				api()
					.get(`/user-access-form/${id}`)
					.then(({ status, data }) => {
						if (status === 200) resolve(data.data);
						throw new Error(`Failed with status: ${status}`);
					})
					.catch((error) => reject(error));
			});
		},

	searchUserAccess: (fields) => {
		return new Promise((resolve, reject) => {
			const filteredFields = Object.entries(fields).filter(
				([key, value]) =>
					value !== undefined && value !== "" && typeof value !== "object"
			);
			const queryString = filteredFields
				.map(
					([key, value]) =>
						`${encodeURIComponent(key)}=${encodeURIComponent(value)}`
				)
				.join("&");

			const url = `/user-access-form-filters?${queryString}`;

			api()
				.get(url)
				.then(({ status, data }) => {
					if (status === 200) {
						resolve(data);
					} else {
						throw new Error(`Failed with status: ${status}`);
					}
				})
				.catch((error) => reject(error));
		});
	},

	postUserAccess: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post("user-access-form", data, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(({ status, data }) => {
					if (status === 201) {
						resolve(data);
					}
				})
				.catch((error) => reject(error));
		});
	},

	updateUserAccess: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`user-access-form/${id}?_method=PUT`, data, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(({ status, data }) => {
					if (status === 201) {
						resolve(data);
					}
				})
				.catch((error) => reject(error));
		});
	},

	deleteUserAccess: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`user-access-form/${id}`)
				.then(({ status, data }) => {
					if (status === 200) {
						resolve(data);
					}
				})
				.catch((error) => reject(error));
		});
	},

	// Additional methods specific to user access
	getUserAccessByDepartment: (departmentId) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/user-access-form/department/${departmentId}`)
				.then(({ status, data }) => {
					if (status === 200) {
						resolve(data);
					} else {
						throw new Error(`Failed with status: ${status}`);
					}
				})
				.catch((error) => reject(error));
		});
	},

	getUserAccessByUser: (userId) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/user-access-form/user/${userId}`)
				.then(({ status, data }) => {
					if (status === 200) {
						resolve(data);
					} else {
						throw new Error(`Failed with status: ${status}`);
					}
				})
				.catch((error) => reject(error));
		});
	},

	// Method to update access status
	updateAccessStatus: (id, status) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`user-access-form/${id}/status`, { status })
				.then(({ status: responseStatus, data }) => {
					if (responseStatus === 200) {
						resolve(data);
					}
				})
				.catch((error) => reject(error));
		});
	},

	// Method to get access types
	getAccessTypes: () => {
		return new Promise((resolve, reject) => {
			api()
				.get("/user-access-form/types")
				.then(({ status, data }) => {
					if (status === 200) {
						resolve(data);
					} else {
						throw new Error(`Failed with status: ${status}`);
					}
				})
				.catch((error) => reject(error));
		});
	},
};
